import { SettingFieldMeta } from '@/types/api';

export function formatSettingLabel(key: string, meta?: SettingFieldMeta): string {
  if (meta?.label) return meta.label;
  const labels: Record<string, string> = {
    TRADING_ENABLED: 'Trading Enabled Switch',
    CAPITAL_PER_TRADE: 'Capital Per Trade',
    MAX_OPEN_POSITIONS: 'Max Open Positions',
    MAX_TRADES_PER_DAY: 'Max Trades Per Day',
    MAX_DAILY_LOSS: 'Max Daily Loss Limit',
    MAX_CONSECUTIVE_LOSSES: 'Max Consecutive Losses',
    STOP_LOSS_PCT: 'Stop Loss Percentage',
    TAKE_PROFIT_PCT: 'Take Profit Percentage',
    TIME_BASED_EXIT_ENABLED: 'Time-Based Force Exit',
    MAX_HOLDING_TIME_MINUTES: 'Max Position Holding Time',
  };
  return labels[key] || key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
